{
  "version": 1,
  "asset_id": "93d71fd7-7498-4a40-8fc0-2a661d8359be",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/93d71fd7-7498-4a40-8fc0-2a661d8359be/hero-abstract-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/93d71fd7-7498-4a40-8fc0-2a661d8359be/hero-abstract-640.webp",
  "original_filename": "hero-abstract-640.webp",
  "size": 16816,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:55Z"
}
